import React, { useContext, useState } from "react";
import clsx from "clsx";

import "./style.scss";
import iconData from "./data";
import Button from "../Button";
import { buildURLForMenuItem } from "../../utils/buildURL";
import { useTranslation } from "react-i18next";
import Link from "../../utils/Link";
import { HomePadding } from "../HomePadding";

export const Needs = ({ data }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(data[0]);

  const onLinkClick = (event, item) => {
    event.preventDefault();
    setSelectedItem(item);
    setShow(false);
  };

  return (
    <HomePadding>
      <section className="site-block site-block--pt-60 site-block--pb-60">
        <div className="wrapper">
          <div className={clsx("needs", { "needs--active": show })}>
            <div className="needs-title">{t("needs.title")}</div>
            <div className="needs-button">
              <button
                type="button"
                className="needs-selected"
                onClick={() => setShow(!show)}
              >
                <div className="needs-selected__icon">
                  {" "}
                  <img
                    src={iconData[selectedItem._type].icon}
                    alt={t(`needs.items.${selectedItem._type}.text`)}
                  />
                </div>
                <p>{t(`needs.items.${selectedItem._type}.text`)}</p>
              </button>
            </div>

            <Button secondary className="needs-link">
              <Link
                to={buildURLForMenuItem(selectedItem)}
                style={{ textDecoration: "none", color: "white" }}
              >
                {t("needs.button.text")}
              </Link>
            </Button>

            <div
              className="needs-options"
              style={{ display: show ? "block" : "none" }}
            >
              <div className="needs-options__inner">
                <ul className="needs-list">
                  {data.map((item, index) => (
                    <li key={index} className="needs-list__item">
                      <button
                        type="button"
                        className={clsx("needs-list__button", {
                          active: item === selectedItem,
                        })}
                        onClick={(e) => onLinkClick(e, item)}
                      >
                        <div className="needs-selected__icon">
                          {" "}
                          <img src={iconData[item._type].icon} />
                        </div>
                        <p>{t(`needs.items.${item._type}.text`)}</p>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HomePadding>
  );
};
